import { render, staticRenderFns } from "./healtMaxSummary.vue?vue&type=template&id=2f3b1d64&"
import script from "./healtMaxSummary.vue?vue&type=script&lang=ts&"
export * from "./healtMaxSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports